import React from 'react'
import './loading.css'
import { Loader } from '@progress/kendo-react-indicators'
const Loading = () => {
  return (
    <div class="loading-container" id="loadingScreen">
        <Loader/>
    </div>
    
  )
}

export default Loading